import { ActionTree } from 'vuex';
import axios, {AxiosResponse} from 'axios';
import { RootState } from '@/store/types';
import {IvrMenuFilter, IvrMenuItem, CallIvrMenusState} from './types';

export const actions: ActionTree<CallIvrMenusState, RootState> = {
  getIvrMenus: ({commit, dispatch}, data: IvrMenuFilter) => {
    commit('setLoading', true);
      return new Promise((resolve, reject) => {
      axios({url: '/acapi/call/ivr_menus', params: data})
        .then(resp => {
          if (data?.page_number > 1) {
            commit('pushIvrMenus', resp.data.ivr_menus);
          } else {
            commit('setIvrMenus', resp.data.ivr_menus);
          }
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
  getIvrMenuItem: ({commit, dispatch},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/call/ivr_menus/${id}`})
        .then((resp:any) => {
          let ivrMenuItem = <IvrMenuItem>resp.data;
            ivrMenuItem.id = id;
          commit('setIvrMenuItem', ivrMenuItem);
          resolve(ivrMenuItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
  saveIvrMenu: ({commit, dispatch}, data: IvrMenuItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
          method: data.id ? 'put' : 'post',
          url: '/acapi/call/ivr_menus/' + (data.id ?? ''),
          data: data
      })
        .then((resp:any) => {
          dispatch('getIvrMenus');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
  deleteIvrMenu: ({commit, dispatch}, data: IvrMenuItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
          method: 'delete',
          url: `/acapi/call/ivr_menus/${data.id}`,
          data: data
      })
        .then((resp:any) => {
          dispatch('getIvrMenus');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
};
